export default __webpack_public_path__ + "static/media/ic-teachers.24da132e.svg";